<template>
    <div class="about">
        <VideoContainer2 v-if="settings.siteName == 'mommydeals'" />
        <div class="top-white-box">
            <div class="top-gray-box">
                <h1>About Us</h1>
            </div>
        </div>
        <div class="page-wrapper">
            <div class="page-contents">
                <p class="text-center"><img :src="settings.logoUrl" class="about-logo"></p>
                <p v-for="(paragraph, index) in settings.aboutUs" :key="index" v-html="paragraph"></p>
                <p><a class="button" href="/JoinWhatsApp" target="_blank" @click="joinWhatsApp">Join {{settings.siteNameCaps}}</a></p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import settings from '@/settings'
import ga from '@/helpers/ga'
import clicky from '@/helpers/clicky'
import api from '@/api'
import VideoContainer2 from '@/components/VideoContainer2.vue'

onMounted(() => {
    document.title = settings.siteNameCaps + ' | About';

    //TEST CONTENTFUL
    api.getBlogPosts().then(response => {
        console.log(response);
    });
});

const joinWhatsApp = () => {
    ga.event('click', { 'event_category': 'whatsapp', 'event_label': 'whatsapp', 'transport_type': 'beacon' });
    clicky.goal("JoinWhatsAppAboutPage")
}
</script>